const isProductionEnvironment = (): boolean => {
  const hostname = (global.location && global.location.hostname) || 'default';
  return hostname.includes('www.xing.com');
};

export const Logger = (function () {
  return {
    log: function (...objects: unknown[]) {
      if (!isProductionEnvironment()) {
        // eslint-disable-next-line no-console
        console.debug(...objects);
      }
    },
  };
})();
